/**
 * RunAI OS Theme Context
 * useAppStore'dan okur — tek kaynak, site ile senkron
 */
import { createContext, useContext } from 'react'
import { useAppStore } from '../../store/useAppStore'

type OSTheme = 'dark' | 'light'

interface OSThemeContextValue {
  theme: OSTheme
  toggle: () => void
  isDark: boolean
}

const OSThemeContext = createContext<OSThemeContextValue>({
  theme: 'dark',
  toggle: () => undefined,
  isDark: true,
})

export function OSThemeProvider({ children }: { children: React.ReactNode }) {
  // useAppStore'dan oku — applyTheme orada cagrilir
  const { theme, toggleTheme } = useAppStore()

  return (
    <OSThemeContext.Provider value={{ theme: theme as OSTheme, toggle: toggleTheme, isDark: theme === 'dark' }}>
      {children}
    </OSThemeContext.Provider>
  )
}

export function useOSTheme() {
  return useContext(OSThemeContext)
}
